import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { APPCONFIG } from '../config';
import 'rxjs/add/operator/map'

@Injectable()
export class AuthenticationService {
  public token: any;
  public refresh_token: any;
  constructor(private http: Http) {
    // set token if saved in local storage
    var currentUser = JSON.parse(localStorage.getItem('currentUserCobranca'));
    this.token = currentUser && currentUser.token;
  }

  login(username: string, password: string, refresh_token: string = null): Observable<boolean> {
    var headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    let body = refresh_token != null ? this.setBodyRefreshToken(refresh_token) : this.setBody(username, password);
    return this.http.post(APPCONFIG.authSettings.authURL, body, {
      headers: headers
    }).map((response: Response) => {

      // login successful if there's a jwt token in the response
      let token = response.json();
      if (token.access_token) {
        this.token = token.access_token;
        this.refresh_token = token.refresh_token;
        // store username and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('currentUserCobranca', JSON.stringify({ username: username, token: token.access_token, telefone: password }));
      }
      return true;
    });
  }

  private setBody(username, password): String {
    return "username=" + username + "&password=" + password + "&client_id=" + APPCONFIG.authSettings.client_id + "&client_secret=" + APPCONFIG.authSettings.client_secret + "&scope=" + APPCONFIG.authSettings.scope + "&grant_type=" + APPCONFIG.authSettings.grant_type
  }

  private setBodyRefreshToken(refresh_token: String) {
    return "refresh_token=" + refresh_token + "&client_id=" + APPCONFIG.authSettings.client_id + "&client_secret=" + APPCONFIG.authSettings.client_secret + "&scope=" + APPCONFIG.authSettings.scope + "&grant_type=" + APPCONFIG.authSettings.grant_type_refreshToken;
  }

  logout(): void {
    // clear token remove user from local storage to log user out
    this.token = null;
    localStorage.removeItem('currentUserCobranca');
  }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/services/authentication.service.ts